import { ApiError } from "@/core/api/apiTypes";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { useForm } from "../hooks/formQueries";
import { FormPreview } from "./FormPreview";

export function FormPreviewContent({ formId, appointmentId, expectedVersionId }: {
  formId: string;
  appointmentId?: string;
  expectedVersionId?: string;
}) {
  const { data: form, isPending, error, refetch } = useForm(formId, appointmentId);
  if (error) {
    if (error instanceof ApiError && [403, 404].includes(error.Status)) {
      return <EmptyState title="Form unavailable" message="This form may have been removed, or you no longer have permission to view it." />;
    }
    return <ErrorState message={error.message} onRetry={() => void refetch()} />;
  }
  if (isPending) return <LoadingSpinner message="Loading form..." />;
  if (!form) return <EmptyState title="Form unavailable" message="This form could not be found." />;
  if (expectedVersionId && form.versionId !== expectedVersionId) {
    return <EmptyState title="This form has changed" message="The available version differs from the form you reviewed. Close this preview and review the updated appointment forms before saving." />;
  }
  return <FormPreview key={`${form.id}:${form.versionId}`} form={form} />;
}
